// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eGLK0{padding:4px 16px;user-select:none}.I5gAK{display:flex;align-items:center;margin:24px 0 12px}.dXYRb{width:24px;margin:0 4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"valueTypeSelect": `eGLK0`,
	"stage": `I5gAK`,
	"closeButtonContainer": `dXYRb`
};
export default ___CSS_LOADER_EXPORT___;
